// Load all the channels within this directory and all subdirectories.
// Channel files must be named *_channel.js.

const channels = require.context('.', true, /_channel\.js$/)
channels.keys().forEach(channels)

const script = document.createElement("script");
script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-element-bundle.min.js";
script.async = true;
document.head.appendChild(script);
